module.exports = __webpack_public_path__ + "static/media/lisa.c6d2a432.jpg";